import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';

import { userConstants, ROUTES } from '../../constants';
import { userService } from '../../services';

const cookies = new Cookies();

const login = (data, history, setShowDropdown) => {
  return dispatch => {
    dispatch(request({data}));

    userService.login(data)
      .then(
        user => {
          const jwt = user.access;
          userService.obtainBearerNetwork(jwt, data)
            .then(
              networks => {
                dispatch(success(user));
                dispatch(obtainNetworkSuccess(networks));
              },
              error => {
                dispatch(obtainNetworkFailure(error.toString()));
                toast.error('Error error!', {
                  autoClose: 4000
                });
              }
            )
        },
        error => {
          dispatch(failure(error.toString()));
          setShowDropdown(false);
          toast.error('Invalid username or password.', {
            autoClose: 4000
          });
        }
      );
  }

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }

  function obtainNetworkSuccess(networks) { return { type: userConstants.OBTAIN_NETWORK_SUCCESS, networks } }
  function obtainNetworkFailure(error) { return { type: userConstants.OBTAIN_NETWORK_FAILURE, error } }
}

const instoreMusicLogin = (data, history, setShowDropdown) => {
  return dispatch => {
    dispatch(request({data}));

    userService.instoreMusiclogin(data)
      .then(
        user => {
          dispatch(success(user));
          history.push(ROUTES.COMMERCIALSUBSCRIPTIONDASHBOARD);
        },
        error => {
          dispatch(failure(error.toString()));
          setShowDropdown(false);
          toast.error('Invalid username or password.', {
            autoClose: 4000
          });
        }
      );
  }

  function request(user) { return { type: userConstants.INSTOREMUSIC_LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.INSTOREMUSIC_LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.INSTOREMUSIC_LOGIN_FAILURE, error } }
}

const signup = (data, history) => {
  return dispatch => {
    userService.signup(data)
      .then(
        user => {
          history.push(ROUTES.COMMERCIALSUBSCRIPTIONLOGIN);
        },
        error => {
          toast.error('Invalid username or password.', {
            autoClose: 4000
          });
        }
      );
  }
}

const obtainBearerToken = (jwt, data, history) => {
  return dispatch => {
    dispatch(request({data}));
  
    userService.obtainBearerToken(jwt, data)
      .then(
        token => {
          history.push(ROUTES.DASHBOARD);
          dispatch(success(token));
      },
      error => {
        dispatch(failure(error.toString()));
        toast.error('Unable to obtain bearer token.', {
          autoClose: 4000
        });
      }
    );
  }

  function request(token) { return { type: userConstants.OBTAIN_TOKEN_REQUEST, token } }
  function success(token) { return { type: userConstants.OBTAIN_TOKEN_SUCCESS, token } }
  function failure(error) { return { type: userConstants.OBTAIN_TOKEN_FAILURE, error } }
}

const contactSales = (data) => {
  console.log(data);
  return dispatch => {
    userService.contactSales(data)
      .then(
        token => {
          window.location.reload();
          // dispatch(success(token));
      },
      error => {
        // dispatch(failure(error.toString()));
        // toast.error('Unable to obtain bearer token.', {
        //   autoClose: 4000
        // });
      }
    );
  }

  // function failure(error) { return { type: userConstants.OBTAIN_TOKEN_FAILURE, error } }
  // function success(token) { return { type: userConstants.OBTAIN_TOKEN_SUCCESS, token } }
}

const logout = (data, history) => {
  // userService.logout(data)
  //   .then(() => {
  //     // remove cookie data
  //     cookies.remove('user', { path: '/' });
  //     cookies.remove('networks', { path: '/' });
  //     cookies.remove('obtainedBearerToken', { path: '/' });
  //   })

  // remove cookie data
  cookies.remove('user', { path: '/' });
  cookies.remove('networks', { path: '/' });
  cookies.remove('obtainedBearerToken', { path: '/' });
  cookies.remove('contentPlaylistData', { path: '/' });
  cookies.remove('myDataObject', { path: '/' });
  cookies.remove('hasTaggedPlaylist', { path: '/' });
  cookies.remove('contentHasTaggedPlaylists', { path: '/' });
  localStorage.removeItem('devices', { path: '/' });

  return { type: userConstants.LOGOUT };
}

export const userActions = {
  login,
  logout,
  obtainBearerToken,
  contactSales,
  signup,
  instoreMusicLogin
}